module.exports = __webpack_public_path__ + "img/table.007eedce.png";